<template>
  <div
    id="file-upload-form"
    class="pb-3"
    v-if="question && question.is_enabled"
  >
    <div v-if="content && content.visible">
      <div class="question-title mb-2">
        {{ question.question }}
        <sup class="text-danger font-weight-bold" v-if="content.required">
          *
        </sup>
      </div>
      <div>
          <ImageRender
            v-if="question.image"
            :imgBase64="question.image" :showCloseButton="false"/>
      </div>
      <b-container class="border rounded">
        <b-row>
          <b-col class="px-3 py-2 text-truncate">
            <b-button @click="$refs.inputFile.click()" class="rounded-0 btn-sm"
              >Choose File
            </b-button>
            <span class="ml-3">{{ fileDisplay }}</span>
          </b-col>
        </b-row>
      </b-container>
      <input
        type="file"
        ref="inputFile"
        v-if="content.visible"
        @change="handleFile"
        :accept="acceptFiles"
        class="d-none"
      />
      <b-form-invalid-feedback :state="isInvalid(question.question)">
        {{ errorMessage(question.question) }}
      </b-form-invalid-feedback>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "FileUpload",
  components: {
    ImageRender,
  },
  data() {
    return {
      fileDisplay: "",
      content: null,
      fileTypes: {
        image: "image/*",
        text: "text/plain",
        pdf: "application/pdf",
        doc:
          ".doc,.docx,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        excel:
          ".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        video: "video/*",
      },
    };
  },
  props: ["question", "answers"],
  methods: {
    ...mapMutations("survey", ["setErrors"]),
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    handleError(error) {
      this.setErrors({
        ...this.errors,
        [this.question.question]: error,
      });
      this.$refs.inputFile.reset();
    },
    handleFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      const file = files[0];
      const allowedFileTypes = this.content.attributes.allowed_file_types;
      let fileType = file.type ? file.type : file.name.split(".").pop();

      if (fileType.includes("image/")) fileType = "image/*";
      if (fileType.includes("video/")) fileType = "video/*";

      if (!this.acceptFiles.includes(fileType)) {
        this.handleError(
          `You can only upload  (${allowedFileTypes.join(", ")}) files.`
        );

        return;
      }

      const bytesPerMb = 1000000;
      const sizeLimit = this.content.attributes.size_limit;

      if (file.size > sizeLimit * bytesPerMb) {
        this.handleError(`You can only upload up to ${sizeLimit} MB.`);

        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileDisplay = file.name;
        this.answers[this.question.question] = {
          name: file.name,
          base64: reader.result,
        };
      };
    },
  },
  computed: {
    ...mapGetters("survey", ["errors"]),
    acceptFiles() {
      let acceptFiles = "";

      if (this.content && this.content.attributes.allowed_file_types.length) {
        this.content.attributes.allowed_file_types.map((allowedFileType) => {
          if (acceptFiles)
            acceptFiles = `${acceptFiles},${this.fileTypes[allowedFileType]}`;
          else acceptFiles = this.fileTypes[allowedFileType];
        });
      }

      return acceptFiles;
    },
  },
  created() {
    if (this.question.contents.length) this.content = this.question.contents[0];

    if (this.answers[this.question.question] === undefined) {
      this.answers[this.question.question] = "";
      this.fileDisplay = "No file chosen";
    } else this.fileDisplay = this.answers[this.question.question].name;
  },
};
</script>

<style>
</style>